<template>
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-12 col-lg-4">
                <classroom-info-card :classroom="classroom" :loading="loading"/>
                <hotline-card v-if="classroom && classroom.converted === false" title="Teach Messages" subtitle="2"
                              :resource-url="baseAPIURL + 'classroom/' + classroom.id + '/message/teacher/'"
                ></hotline-card>
                <hotline-card v-if="classroom && classroom.converted" title="All Teachers Messages" subtitle="2"
                              :resource-url="baseAPIURL + 'classroom/' + classroom.id + '/message/all-teachers/'"
                ></hotline-card>
            </div>
            <div class="col-md-12 col-lg-8">

                <div class="btn-group center">
                    <button type="button" @click="setTab('students')" class="btn btn-info btn-outline"
                            v-bind:class="{ 'btn-simple': currentTab !== 'students' }">
                        Students
                    </button>
                    <button type="button" @click="setTab('subjects')" class="btn btn-info btn-outline"
                            v-bind:class="{ 'btn-simple': currentTab !== 'subjects' }">
                        Subjects
                    </button>
                    <button type="button" @click="setTab('conference')" class="btn btn-info btn-outline"
                            v-bind:class="{ 'btn-simple': currentTab !== 'conference' }">
                        Conference History
                    </button>
                    <button type="button" @click="setTab('old_files')" class="btn btn-info btn-outline"
                            v-bind:class="{ 'btn-simple': currentTab !== 'old_files' }">
                        Old files
                    </button>
                    <button type="button" @click="setTab('live_conference')" class="btn btn-info btn-outline"
                            v-bind:class="{ 'btn-simple': currentTab !== 'live_conference' }">
                        Live Conference
                    </button>
                </div>
                <hr>
                <div class="row">
                    <div class="col" v-if="currentTab === 'students'">
                        <student-table :students="students" @updated="loadStudents"></student-table>
                    </div>
                    <div class="col" v-if="currentTab === 'subjects'">
                        <classroom-subjects :classroom="classroom"/>
                    </div>

                    <div class="col" v-if="currentTab === 'conference'">
                        <conference-overview :classroom="classroom"></conference-overview>
                    </div>

                    <div class="col" v-if="currentTab === 'live_conference'">
                        <live-conference-overview :classroom="classroom"></live-conference-overview>
                    </div>

                    <div class="col" v-if="currentTab === 'old_files'">
                        <old_files-table :classroom="classroom"/>
                    </div>
                </div>


            </div>
        </div>

    </div>
</template>

<script>

import axios from "axios";
import HotlineCard from "./HotlineCard";
import StudentTable from "./Student/StudentTable";
import ConferenceOverview from "./ConferenceOverview";
import ClassroomInfoCard from "./ClassroomInfoCard";
import ClassroomSubjects from "./ClassroomSubjects";
import Old_filesTable from "./Old_filesTable";
import LiveConferenceOverview from "@/pages/School/LiveConferenceOverview";


export default {
    components: {
        LiveConferenceOverview,
        Old_filesTable,
        ClassroomSubjects,
        ClassroomInfoCard,
        ConferenceOverview,
        HotlineCard,
        StudentTable,

    },
    data() {
        return {
            students: [],
            classroom: {},
            voicemail: {},
            messages: {
                teacher: {
                    uploading: false,
                    uploadingTemporaryMessage: false,
                    loadingMessages: true,
                    loadingTemporaryMessage: true,
                    messages: [],
                    removing: [],
                    temporaryMessage: false,
                    recording: null,
                },
                lessons: {
                    uploading: false,
                    uploadingTemporaryMessage: false,
                    loadingMessages: true,
                    loadingTemporaryMessage: true,
                    messages: [],
                    removing: [],
                    temporaryMessage: false,
                    recording: null,
                },
                other: {
                    uploading: false,
                    uploadingTemporaryMessage: false,
                    loadingMessages: true,
                    loadingTemporaryMessage: true,
                    messages: [],
                    removing: [],
                    temporaryMessage: false,
                    recording: null,
                },
            },
            loading: {
                students: true,
                classroom: true,
                voicemail: true,
            },
            currentTab: 'students',

        };
    },
    computed: {
        enableRTL() {
            return this.$route.query.enableRTL;
        },
        isRTL() {
            return this.$rtl.isRTL;
        },

    },
    methods: {
        setTab(tab) {
            this.currentTab = tab;
        },
        updateShow(value) {
            this.showCreateModal = value;
        },
        loadClassroom() {
            this.loading.classroom = true;
            return axios({
                url: this.baseAPIURL + 'classroom/' + this.$route.params.classroom, method: 'GET', headers: {
                    'Access-Control-Allow-Origin': '*',
                    'Content-Type': 'application/json',
                },
            }).then(resp => {
                this.classroom = resp.data.data;
                this.classroom.allow_login = Boolean(this.classroom.allow_login);
            }).finally(() => {
                this.loading.classroom = false;
            });
        },
        loadStudents() {
            this.loading.students = true;
            axios({
                url: this.baseAPIURL + 'classroom/' + this.classroom.id + '/student', method: 'GET', headers: {
                    'Access-Control-Allow-Origin': '*',
                    'Content-Type': 'application/json',
                },
            }).then(resp => {
                this.students = resp.data.data;
            }).finally(() => {
                this.loading.students = false;
            });
        },
    },
    mounted() {
        this.i18n = this.$i18n;
        if (this.enableRTL) {
            this.i18n.locale = 'ar';
            this.$rtl.enableRTL();
        }

        this.loadClassroom().then(() => {
            this.loadStudents();
        })
    },
    beforeDestroy() {
        if (this.$rtl.isRTL) {
            this.i18n.locale = 'en';
            this.$rtl.disableRTL();
        }
    }
};
</script>
<style>
.white-content .el-table table > tbody > tr > td {
    padding: 4px 2px;
}

.white-content .el-table table > tbody > tr > td .plyr--audio .plyr__controls {
    padding: 0;
}

.tab-content .tab-pane {
    color: rgb(203, 81, 226);
}
</style>
